// extracted by mini-css-extract-plugin
export default {"WindWrapper":"Wind_WindWrapper__lOz5m","WindText":"Wind_WindText__grgzN","UnitsText":"Wind_UnitsText__NK1fl"};